import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyCustom = loadable(() => import(/* webpackChunkName: "content/guest/widgets/custom" */ './components/Honeymoon/CustomHoneymoon.router'), 'Custom');
